import styled from '@emotion/styled';
import { Alert, Form, InputNumber, Radio } from 'antd';
import { FV } from './share';
import useSmartField from 'hooks/useSmartField';
import TransComponent from 'components/TransComponent';
import { DisabledProps, ScenarioTypeProps } from '../TaskForm/share';
import { T, useTranslate } from '@tolgee/react';

const Container = styled.div`
  > * {
    margin-bottom: 6px;
  }
  .${({ theme }) => theme.getAntdPrefixedClassName('alert')} {
    display: inline-block;
  }
  .${({ theme }) => theme.getAntdPrefixedClassName('input-number')} {
    margin: 0 4px;
  }
`;

function AutoReviewDelayDay({ scenarioType, disabled }: ScenarioTypeProps & DisabledProps) {
  const { t } = useTranslate();

  const {
    field: { value, onChange },
  } = useSmartField<FV['autoReviewConfig']>('autoReviewConfig');

  if (scenarioType !== 'NEGATIVE_REVIEW_REPLY' && scenarioType !== 'POSITIVE_REVIEW_REPLY') {
    return null;
  }

  const { delayAutoReview, delayDay } = value || {};

  const delay = Boolean(delayAutoReview || delayDay > 0);

  const radios = (
    <div className="mt-[4px]">
      <Radio
        disabled={disabled}
        checked={delay}
        onChange={({ target: { checked } }) => {
          onChange({
            ...value,
            delayAutoReview: checked,
            delayDay: checked ? 5 : 0,
          });
        }}
      >
        {t('marketing.是')}
      </Radio>
      <Radio
        disabled={disabled}
        checked={!delay}
        onChange={({ target: { checked } }) => {
          onChange({
            ...value,
            delayAutoReview: !checked,
            delayDay: checked ? 0 : 5,
          });
        }}
      >
        {t('marketing.否')}
      </Radio>
    </div>
  );

  const inputNumber = (
    <InputNumber
      disabled={disabled}
      value={delayDay}
      onChange={(delayDay) =>
        onChange({
          ...value,
          delayDay: delayDay || 5,
        })
      }
      min={1}
      max={30}
      precision={0}
    />
  );

  return (
    <Form.Item required label={t('aide.延时回评')}>
      <Container>
        {scenarioType === 'NEGATIVE_REVIEW_REPLY' && (
          <Alert
            banner
            showIcon={false}
            type="info"
            message={t(
              'aide.同一个店铺下，同时配置了同一星级的中差评自动回评与中差评挽回，支持延时触发中差评自动回评。',
            )}
          />
        )}
        {radios}
        {delay && (
          <div>
            <T
              keyName={
                scenarioType === 'POSITIVE_REVIEW_REPLY'
                  ? 'aide.买家进行好评x天后，对该评价自动回评'
                  : 'aide.发送中差评挽回话术后，且买家在x天内未回复，对该评价自动回评。若无生效中的中差评挽回话术，则会立即回评'
              }
              params={{
                x: <TransComponent content={inputNumber} />,
              }}
            />
          </div>
        )}
      </Container>
    </Form.Item>
  );
}

export default AutoReviewDelayDay;
